import PrivateHealthPracticeHub from './PrivateHealthPracticeHub';
export default PrivateHealthPracticeHub; 